//QC Stages
export const GET_QC_STAGE = "GET_QC_STAGE";
export const GET_QC_STAGE_EXPORT = "GET_QC_STAGE_EXPORT";
export const GET_QC_STAGE_FILTER_ACTIVITY = "GET_QC_STAGE_FILTER_ACTIVITY";
//qc check point
export const GET_QC_CHECK_POINT = "GET_QC_CHECK_POINT";
export const GET_QC_CHECK_POINT_EXPORT = "GET_QC_CHECK_POINT_EXPORT";
export const GET_QC_CHECK_POINT_OPTION = "GET_QC_CHECK_POINT_OPTION";
export const GET_QC_CHECK_POINT_OPTION_EXPORT = "GET_QC_CHECK_POINT_OPTION_EXPORT";
export const GET_QC_CHECK_POINT_OPTION_MAP = "GET_QC_CHECK_POINT_OPTION_MAP";
export const GET_QC_CHECK_POINT_OPTION_MAP_EXPORT = "GET_QC_CHECK_POINT_OPTION_MAP_EXPORT";
export const GET_QC_STAGE_CHECK_POINT_MAP = "GET_QC_STAGE_CHECK_POINT_MAP";
export const GET_QC_STAGE_CHECK_POINT_MAP_EXPORT = "GET_QC_STAGE_CHECK_POINT_MAP_EXPORT";
export const GET_QC_REQUEST = "GET_QC_REQUEST";
export const GET_QC_REQUEST_EXPORT = "GET_QC_REQUEST_EXPORT";
export const GET_ACTUAL_ENTRY_FOR_QC_REQUEST =
  "GET_ACTUAL_ENTRY_FOR_QC_REQUEST";
export const GET_QC_REQUEST_DETAILS = "GET_QC_REQUEST_DETAILS";
export const GET_ACTIVITY_FOR_QC_REQUEST = "GET_ACTIVITY_FOR_QC_REQUEST";
export const GET_QC_CHECK_POINT_BY_STAGE = "GET_QC_CHECK_POINT_BY_STAGE";
export const GET_QC_REQUEST_REVIEW = "GET_QC_REQUEST_REVIEW";
export const GET_QC_REQUEST_APPROVE = "GET_QC_REQUEST_APPROVE";
export const GET_QC_REQUEST_REVIEW_EXPORT = "GET_QC_REQUEST_REVIEW_EXPORT";
export const GET_QC_REQUEST_APPROVE_EXPORT = "GET_QC_REQUEST_APPROVE_EXPORT";
export const GET_QC_INSTRUCTION = "GET_QC_INSTRUCTION";
export const GET_QC_INSTRUCTION_EXPORT = "GET_QC_INSTRUCTION_EXPORT";
export const GET_INSTRUCTION_FILTER_PROJECT = "GET_INSTRUCTION_FILTER_PROJECT";
export const GET_INSTRUCTION_FILTER_ASSIGNED_TO =
  "GET_INSTRUCTION_FILTER_ASSIGNED_TO";
export const GET_INSTRUCTION_FILTER_RAISED_BY =
  "GET_INSTRUCTION_FILTER_RAISED_BY";
export const GET_QC_INSTRUCTION_DETAIL = "GET_QC_INSTRUCTION_DETAIL";
export const GET_QC_INSTRUCTION_FOR_QC = "GET_QC_INSTRUCTION_FOR_QC";
export const GET_QC_INSPECTION_FILTER_PROJECT =
  "GET_QC_INSPECTION_FILTER_PROJECT";
export const GET_WBS_FOR_QC_REQUEST = "GET_WBS_FOR_QC_REQUEST";
export const GET_LOCATION_FOR_QC = "GET_LOCATION_FOR_QC";
export const GET_QC_INSPECTION_FILTER_PROCESS = "GET_QC_INSPECTION_FILTER_PROCESS";
export const GET_QC_INSPECTION_FILTER_ACTIVITY = "GET_QC_INSPECTION_FILTER_ACTIVITY";
export const CREATE_QC_REQUEST = "CREATE_QC_REQUEST";
export const GET_ASSIGNEE_FOR_INSTRUCTION = "GET_ASSIGNEE_FOR_INSTRUCTION";
export const GET_QC_REQUEST_ITEM1 = "GET_QC_REQUEST_ITEM1";
export const GET_QC_INSPECTION_REVIEW_FILTER_PROJECT = "GET_QC_INSPECTION_REVIEW_FILTER_PROJECT";
export const GET_QC_INSPECTION_REVIEW_FILTER_PROCESS = "GET_QC_INSPECTION_REVIEW_FILTER_PROCESS";
export const GET_QC_INSPECTION_REVIEW_FILTER_ACTIVITY = "GET_QC_INSPECTION_REVIEW_FILTER_ACTIVITY";
// QC WALKTHROUGH
export const GET_QC_WALKTHROUGH = "GET_QC_WALKTHROUGH";
export const GET_QC_WALKTHROUGH_EXPORT = "GET_QC_WALKTHROUGH_EXPORT";
export const GET_QC_WALKTHROUGH_DETAIL = "GET_QC_WALKTHROUGH_DETAIL";
export const GET_QC_WALKTHROUGH_FILTER_PROJECT = "GET_QC_WALKTHROUGH_FILTER_PROJECT";